// import { useState, useRef, useCallback } from "react";
// import { BASE_URL } from "../../apiConfig";
// import { useAuth } from "../../context/AuthProvider";
// import { toast } from "sonner";

// // ── Extract items WITH their x/y coordinates from pdf.js ─────────────────────
// async function extractTokensFromPDF(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = async (e) => {
//       try {
//         const typedarray = new Uint8Array(e.target.result);
//         const pdfjsLib = window["pdfjs-dist/build/pdf"];
//         if (!pdfjsLib) throw new Error("pdf.js not loaded");
//         pdfjsLib.GlobalWorkerOptions.workerSrc =
//           "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

//         const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;

//         // Collect positioned items across all pages
//         const allItems = [];
//         let pageYOffset = 0;

//         for (let p = 1; p <= pdf.numPages; p++) {
//           const page = await pdf.getPage(p);
//           const viewport = page.getViewport({ scale: 1 });
//           const content = await page.getTextContent();

//           content.items.forEach((item) => {
//             const t = item.str.trim();
//             if (!t) return;
//             // transform[4] = x,  transform[5] = y (PDF coords, bottom-up)
//             const x = item.transform[4];
//             const y = viewport.height - item.transform[5] + pageYOffset; // flip to top-down
//             allItems.push({ text: t, x, y });
//           });

//           pageYOffset += viewport.height + 20; // stack pages vertically
//         }

//         resolve(allItems);
//       } catch (err) {
//         reject(err);
//       }
//     };
//     reader.onerror = reject;
//     reader.readAsArrayBuffer(file);
//   });
// }

// // ── Group items into logical rows by Y proximity, then sort each row by X ─────
// function groupIntoRows(items, yTolerance = 4) {
//   const sorted = [...items].sort((a, b) => a.y - b.y);
//   const rows = [];

//   for (const item of sorted) {
//     const last = rows[rows.length - 1];
//     if (last && Math.abs(item.y - last[0].y) <= yTolerance) {
//       last.push(item);
//     } else {
//       rows.push([item]);
//     }
//   }

//   // Sort each row left-to-right
//   rows.forEach((r) => r.sort((a, b) => a.x - b.x));
//   return rows;
// }

// // ── Parse using X-column bands (from debug: code=66, dates=169/233, status=298, ville=352, crbt=422, frais=476, total=519)
// function parseOzonInvoice(items) {
//   const flat = items.map((i) => i.text).join(" ");

//   // Meta
//   const invoiceMatch = flat.match(/Facture\s*:\s*(FCT-[\w-]+)/i);
//   const dateMatch    = flat.match(/Date\s*:\s*([\d-]+\s[\d:]+)/i);
//   const totalMatch   = flat.match(/Total\s*Net\s*([\d,.]+)/i) || flat.match(/Total\s*:\s*([\d,.]+)\s*DH/i);
//   const colisMatch   = flat.match(/Colis\s*:\s*(\d+)/i);

//   const meta = {
//     invoice : invoiceMatch?.[1] ?? "–",
//     date    : dateMatch?.[1]    ?? "–",
//     total   : totalMatch?.[1]   ?? "–",
//     colis   : colisMatch?.[1]   ?? "–",
//   };

//   // Column X ranges (with tolerance ±15px)
//   // From debug: code≈66, dateRam≈169, dateLiv≈233, status≈298, ville≈352, crbt≈422, frais≈476, total≈519
//   const inCol = (x, center) => Math.abs(x - center) < 20;

//   const COL_CODE   = 66;
//   const COL_DRAM   = 169;
//   const COL_DLIV   = 233;
//   const COL_STATUS = 298;
//   const COL_VILLE  = 352;
//   const COL_CRBT   = 422;
//   const COL_FRAIS  = 476;
//   const COL_TOTAL  = 519;

//   const DATE_RE  = /^\d{4}-\d{2}-\d{2}$/;
//   const PHONE_RE = /^0\d{9}$/;
//   const extractAmount = (t) => { const m = t.match(/^([\d]+([.,]\d+)?)\s*(?:DH)?$/i); return m ? m[1] : null; };

//   // Filter only table items (y > 200, x between 30–560, skip header/footer text)
//   const tableItems = items.filter(item => {
//     if (item.y < 200) return false; // above table
//     if (item.x < 30 || item.x > 560) return false;
//     const t = item.text;
//     if (["DH", "N°", "1 / 2", "2 / 2"].includes(t)) return false;
//     if (/^(ramassage|livraison|Total|Sauf|Ozon|Powered)/i.test(t)) return false;
//     return true;
//   });

//   // Find all Y positions that have a row-number at x≈34 (the leftmost column)
//   // These Y values anchor each invoice row
//   const rowNumberItems = tableItems.filter(item =>
//     item.x < 50 && /^\d{1,2}$/.test(item.text)
//   ).sort((a, b) => a.y - b.y);

//   const rows = [];

//   for (let ri = 0; ri < rowNumberItems.length; ri++) {
//     const anchorY = rowNumberItems[ri].y;
//     const nextAnchorY = rowNumberItems[ri + 1]?.y ?? anchorY + 60;

//     // Grab all items belonging to this invoice row (between this anchor and next)
//     const block = tableItems.filter(item =>
//       item.y >= anchorY - 2 && item.y < nextAnchorY - 2
//     );

//     // Collect text per column by X band, sorted by Y then X
//     const col = (center) => block
//       .filter(item => inCol(item.x, center))
//       .sort((a, b) => a.y - b.y || a.x - b.x)
//       .map(i => i.text);

//     // Code column: may be "OZN-" + "TOPSELLER-169" across two lines → join
//     const codeTokens = col(COL_CODE).filter(t => !/^\d{1,2}$/.test(t) && !PHONE_RE.test(t) && !DATE_RE.test(t));
//     const rawCode = codeTokens.join("").replace(/\s+/g, "");
//     if (!rawCode.toUpperCase().startsWith("OZN")) continue; // skip non-order rows

//     // Phone: first 10-digit token in code column
//     const phone = col(COL_CODE).find(t => PHONE_RE.test(t)) ?? "–";

//     // Dates
//     const dateRamTokens = col(COL_DRAM).filter(t => DATE_RE.test(t));
//     const dateLivTokens = col(COL_DLIV).filter(t => DATE_RE.test(t));
//     const dateRamassage = dateRamTokens[0] ?? "–";
//     const dateLivraison = dateLivTokens[0] ?? "–";

//     // Status
//     const status = col(COL_STATUS).find(t => /^(livr|refus|retourn|annul|report)/i.test(t)) ?? "–";

//     // Ville: join all tokens in ville column
//     const ville = col(COL_VILLE)
//       .filter(t => t !== "DH")
//       .join(" ")
//       .trim();

//     // Amounts — strip "DH" suffix if merged
//     const crbtRaw  = col(COL_CRBT).find(t => extractAmount(t) !== null) ?? "0";
//     const fraisRaw = col(COL_FRAIS).find(t => extractAmount(t) !== null) ?? "0";
//     const totalRaw = col(COL_TOTAL).find(t => extractAmount(t) !== null) ?? "0";

//     const crbt  = extractAmount(crbtRaw)  ?? crbtRaw;
//     const frais = extractAmount(fraisRaw) ?? fraisRaw;
//     const total = extractAmount(totalRaw) ?? totalRaw;

//     rows.push({
//       code: rawCode,
//       phone,
//       dateRamassage,
//       dateLivraison,
//       status,
//       ville,
//       crbt,
//       frais,
//       total,
//       selected: status.toLowerCase().startsWith("livr"),
//     });
//   }

//   return { meta, rows };
// }

// // ── Status badge ───────────────────────────────────────────────────────────────
// function StatusBadge({ status }) {
//   const s = status.toLowerCase();
//   if (s === "livré")
//     return (
//       <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700 border border-emerald-200">
//         <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
//         Livré
//       </span>
//     );
//   if (s === "refusé")
//     return (
//       <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-red-100 text-red-600 border border-red-200">
//         <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
//         Refusé
//       </span>
//     );
//   return (
//     <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-600 border border-gray-200">
//       <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
//       {status}
//     </span>
//   );
// }

// // ── Main component ─────────────────────────────────────────────────────────────
// export default function OzonInvoiceImporter({ onClose }) {
//   const { token } = useAuth();
//   const fileRef = useRef();

//   const [stage, setStage] = useState("idle"); // idle | parsing | preview | debug | importing | done
//   const [meta, setMeta] = useState(null);
//   const [rows, setRows] = useState([]);
//   const [results, setResults] = useState([]); // { code, success, message }
//   const [dragging, setDragging] = useState(false);
//   const [error, setError] = useState("");
//   const [rawItems, setRawItems] = useState([]);
//   const [visualRows, setVisualRows] = useState([]);

//   // ── File handling ────────────────────────────────────────────────────────────
//   const handleFile = useCallback(async (file) => {
//     if (!file || file.type !== "application/pdf") {
//       setError("Veuillez sélectionner un fichier PDF valide.");
//       return;
//     }
//     setError("");
//     setStage("parsing");
//     try {
//       const items = await extractTokensFromPDF(file);
//       const vRows = groupIntoRows(items);
//       setRawItems(items);
//       setVisualRows(vRows);
//       const { meta, rows } = parseOzonInvoice(items);
//       setMeta(meta);
//       setRows(rows);
//       // Go to debug first so we can inspect
//       setStage("debug");
//     } catch (err) {
//       setError("Erreur lors de la lecture du PDF : " + err.message);
//       setStage("idle");
//     }
//   }, []);

//   const onDrop = useCallback(
//     (e) => {
//       e.preventDefault();
//       setDragging(false);
//       handleFile(e.dataTransfer.files[0]);
//     },
//     [handleFile]
//   );

//   const toggleRow = (idx) =>
//     setRows((prev) =>
//       prev.map((r, i) => (i === idx ? { ...r, selected: !r.selected } : r))
//     );

//   const toggleAll = () => {
//     const livreRows = rows.filter((r) => r.status.toLowerCase() === "livré");
//     const allSelected = livreRows.every((r) => r.selected);
//     setRows((prev) =>
//       prev.map((r) =>
//         r.status.toLowerCase() === "livré" ? { ...r, selected: !allSelected } : r
//       )
//     );
//   };

//   // ── Import: call backend for each selected "Livré" order ─────────────────────
//   const handleImport = async () => {
//     const selected = rows.filter((r) => r.selected && r.status.toLowerCase() === "livré");
//     if (!selected.length) {
//       toast.warning("Aucune commande sélectionnée.");
//       return;
//     }

//     setStage("importing");
//     const res = [];

//     for (const row of selected) {
//       try {
//         const response = await fetch(`${BASE_URL}/api/ozon-update-status`, {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             code_api: row.code,
//             status: "Livre(paye)",
//           }),
//         });
//         const data = await response.json();
//         res.push({
//           code: row.code,
//           ville: row.ville,
//           success: response.ok && data.success,
//           message: data.message ?? (response.ok ? "Mis à jour" : "Erreur"),
//         });
//       } catch (err) {
//         res.push({ code: row.code, ville: row.ville, success: false, message: err.message });
//       }
//     }

//     setResults(res);
//     setStage("done");

//     const ok = res.filter((r) => r.success).length;
//     const fail = res.filter((r) => !r.success).length;
//     if (fail === 0) toast.success(`${ok} commande(s) mises à jour avec succès.`);
//     else toast.warning(`${ok} succès, ${fail} échec(s).`);
//   };

//   // ── Derived ──────────────────────────────────────────────────────────────────
//   const livreCount = rows.filter((r) => r.status.toLowerCase() === "livré").length;
//   const selectedCount = rows.filter((r) => r.selected).length;
//   const allLivreSelected =
//     livreCount > 0 && rows.filter((r) => r.status.toLowerCase() === "livré").every((r) => r.selected);

//   // ── Render ───────────────────────────────────────────────────────────────────
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
//       <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl max-h-[92vh] flex flex-col overflow-hidden border border-gray-100">

//         {/* Header */}
//         <div className="flex items-center justify-between px-7 py-5 border-b border-gray-100 shrink-0">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-orange-100 flex items-center justify-center">
//               <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//               </svg>
//             </div>
//             <div>
//               <h2 className="text-base font-bold text-gray-900">Importer Facture Ozon</h2>
//               {meta && (
//                 <p className="text-[11px] text-gray-400 mt-0.5">
//                   {meta.invoice} · {meta.date} · {meta.colis} colis · {meta.total} DH
//                 </p>
//               )}
//             </div>
//           </div>
//           <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//             </svg>
//           </button>
//         </div>

//         {/* Body */}
//         <div className="flex-1 overflow-y-auto px-7 py-6">

//           {/* ── IDLE / DROP ZONE ── */}
//           {(stage === "idle" || stage === "parsing") && (
//             <div
//               onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
//               onDragLeave={() => setDragging(false)}
//               onDrop={onDrop}
//               onClick={() => fileRef.current?.click()}
//               className={`border-2 border-dashed rounded-2xl flex flex-col items-center justify-center cursor-pointer select-none transition-all duration-200 py-16
//                 ${dragging ? "border-orange-400 bg-orange-50" : "border-gray-200 bg-gray-50 hover:border-orange-300 hover:bg-orange-50/50"}`}
//             >
//               <input
//                 ref={fileRef}
//                 type="file"
//                 accept="application/pdf"
//                 className="hidden"
//                 onChange={(e) => handleFile(e.target.files[0])}
//               />
//               {stage === "parsing" ? (
//                 <>
//                   <div className="w-10 h-10 border-4 border-orange-400 border-t-transparent rounded-full animate-spin mb-4" />
//                   <p className="text-sm text-gray-500 font-medium">Lecture du PDF en cours…</p>
//                 </>
//               ) : (
//                 <>
//                   <div className="w-14 h-14 rounded-2xl bg-orange-100 flex items-center justify-center mb-4">
//                     <svg className="w-7 h-7 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
//                     </svg>
//                   </div>
//                   <p className="text-sm font-semibold text-gray-700 mb-1">Glissez votre facture PDF ici</p>
//                   <p className="text-xs text-gray-400">ou cliquez pour sélectionner</p>
//                 </>
//               )}
//               {error && (
//                 <p className="mt-4 text-xs text-red-500 bg-red-50 px-4 py-2 rounded-xl">{error}</p>
//               )}
//             </div>
//           )}

//           {/* ── DEBUG ── */}
//           {stage === "debug" && (
//             <div className="space-y-4">
//               <div className="flex items-center justify-between">
//                 <p className="text-sm font-semibold text-gray-700">
//                   Debug: {rawItems.length} tokens bruts · {visualRows.length} lignes visuelles · {rows.length} lignes parsées
//                 </p>
//                 <button
//                   onClick={() => setStage("preview")}
//                   className="text-xs bg-orange-500 text-white px-4 py-1.5 rounded-xl"
//                 >
//                   Voir prévisualisation →
//                 </button>
//               </div>

//               {/* Visual rows — what the parser actually sees */}
//               <div>
//                 <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wider">Lignes visuelles (groupées par Y)</p>
//                 <div className="rounded-xl border border-gray-200 overflow-auto max-h-80 text-[10px] font-mono">
//                   {visualRows.map((row, i) => (
//                     <div key={i} className={`flex gap-2 px-3 py-1 border-b border-gray-100 ${row.some(t => /OZN/i.test(t.text)) ? "bg-yellow-50" : i % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
//                       <span className="text-gray-400 w-6 shrink-0">{i}</span>
//                       <span className="text-gray-400 w-20 shrink-0">y≈{Math.round(row[0].y)}</span>
//                       <span className="text-gray-700 flex flex-wrap gap-1">
//                         {row.map((t, j) => (
//                           <span key={j} className="bg-gray-200 px-1 rounded">{t.text}</span>
//                         ))}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Parsed rows result */}
//               <div>
//                 <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wider">Résultat du parsing ({rows.length} lignes)</p>
//                 {rows.length === 0 ? (
//                   <p className="text-xs text-red-500 bg-red-50 p-3 rounded-xl">Aucune ligne parsée — examinez les lignes visuelles ci-dessus pour voir pourquoi</p>
//                 ) : (
//                   <div className="rounded-xl border border-gray-200 overflow-auto max-h-48 text-[10px] font-mono">
//                     {rows.map((r, i) => (
//                       <div key={i} className="px-3 py-1 border-b border-gray-100 bg-white">
//                         <span className="text-orange-600 font-bold mr-2">{r.code}</span>
//                         <span className="text-gray-500 mr-2">{r.phone}</span>
//                         <span className="text-blue-600 mr-2">{r.status}</span>
//                         <span className="text-gray-600 mr-2">"{r.ville}"</span>
//                         <span className="text-emerald-600">{r.crbt} / {r.frais} / {r.total}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Copy all tokens as JSON for sharing */}
//               <div>
//                 <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wider">Tokens bruts (copiez et partagez)</p>
//                 <textarea
//                   readOnly
//                   className="w-full h-24 text-[9px] font-mono bg-gray-900 text-green-400 p-2 rounded-xl resize-none"
//                   value={JSON.stringify(rawItems.slice(0, 200).map(i => `[${Math.round(i.x)},${Math.round(i.y)}] "${i.text}"`), null, 0).replace(/","/g, '",\n"')}
//                 />
//               </div>
//             </div>
//           )}

//           {/* ── PREVIEW ── */}
//           {stage === "preview" && (
//             <>
//               {/* Summary pills */}
//               <div className="flex flex-wrap gap-3 mb-5">
//                 <span className="px-3 py-1.5 bg-gray-100 rounded-xl text-xs font-medium text-gray-600">
//                   Total colis : <strong>{rows.length}</strong>
//                 </span>
//                 <span className="px-3 py-1.5 bg-emerald-50 rounded-xl text-xs font-medium text-emerald-700 border border-emerald-100">
//                   Livré : <strong>{livreCount}</strong>
//                 </span>
//                 <span className="px-3 py-1.5 bg-red-50 rounded-xl text-xs font-medium text-red-600 border border-red-100">
//                   Refusé : <strong>{rows.filter(r => r.status.toLowerCase() === "refusé").length}</strong>
//                 </span>
//                 <span className="px-3 py-1.5 bg-orange-50 rounded-xl text-xs font-medium text-orange-600 border border-orange-100">
//                   Sélectionné : <strong>{selectedCount}</strong>
//                 </span>
//               </div>

//               <div className="rounded-2xl border border-gray-100 overflow-hidden">
//                 <table className="w-full text-xs">
//                   <thead className="bg-gray-50 border-b border-gray-100">
//                     <tr>
//                       <th className="px-4 py-3 text-left">
//                         <input
//                           type="checkbox"
//                           checked={allLivreSelected}
//                           onChange={toggleAll}
//                           className="rounded accent-orange-500"
//                           title="Sélectionner tous les Livrés"
//                         />
//                       </th>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Code</th>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Téléphone</th>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Ville</th>
//                       <th className="px-4 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">Status</th>
//                       <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">Crbt</th>
//                       <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">Frais</th>
//                       <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">Net</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-50">
//                     {rows.map((row, idx) => {
//                       const isLivre = row.status.toLowerCase() === "livré";
//                       return (
//                         <tr
//                           key={idx}
//                           onClick={() => isLivre && toggleRow(idx)}
//                           className={`transition-colors ${isLivre ? "cursor-pointer hover:bg-orange-50/40" : "opacity-50"} ${row.selected ? "bg-orange-50/60" : ""}`}
//                         >
//                           <td className="px-4 py-2.5">
//                             <input
//                               type="checkbox"
//                               checked={row.selected}
//                               disabled={!isLivre}
//                               onChange={() => toggleRow(idx)}
//                               className="rounded accent-orange-500"
//                             />
//                           </td>
//                           <td className="px-4 py-2.5 font-mono font-medium text-gray-800">{row.code}</td>
//                           <td className="px-4 py-2.5 text-gray-500">{row.phone}</td>
//                           <td className="px-4 py-2.5 text-gray-600">{row.ville}</td>
//                           <td className="px-4 py-2.5 text-center"><StatusBadge status={row.status} /></td>
//                           <td className="px-4 py-2.5 text-right font-medium text-gray-700">{row.crbt} DH</td>
//                           <td className="px-4 py-2.5 text-right text-red-500">-{row.frais} DH</td>
//                           <td className="px-4 py-2.5 text-right font-bold text-emerald-700">{row.total} DH</td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               <p className="mt-4 text-xs text-gray-400 text-center">
//                 Seules les commandes <strong>Livré</strong> peuvent être sélectionnées. Le statut sera mis à jour en <strong>Livre(paye)</strong>.
//               </p>
//             </>
//           )}

//           {/* ── IMPORTING ── */}
//           {stage === "importing" && (
//             <div className="flex flex-col items-center justify-center py-16 gap-4">
//               <div className="w-12 h-12 border-4 border-orange-400 border-t-transparent rounded-full animate-spin" />
//               <p className="text-sm font-semibold text-gray-700">Mise à jour des commandes en cours…</p>
//               <p className="text-xs text-gray-400">Veuillez patienter</p>
//             </div>
//           )}

//           {/* ── DONE ── */}
//           {stage === "done" && (
//             <>
//               <div className="flex flex-wrap gap-3 mb-5">
//                 <span className="px-3 py-1.5 bg-emerald-50 rounded-xl text-xs font-medium text-emerald-700 border border-emerald-100">
//                   ✓ Succès : <strong>{results.filter(r => r.success).length}</strong>
//                 </span>
//                 {results.filter(r => !r.success).length > 0 && (
//                   <span className="px-3 py-1.5 bg-red-50 rounded-xl text-xs font-medium text-red-600 border border-red-100">
//                     ✗ Échecs : <strong>{results.filter(r => !r.success).length}</strong>
//                   </span>
//                 )}
//               </div>

//               <div className="rounded-2xl border border-gray-100 overflow-hidden">
//                 <table className="w-full text-xs">
//                   <thead className="bg-gray-50 border-b border-gray-100">
//                     <tr>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Code</th>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Ville</th>
//                       <th className="px-4 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">Résultat</th>
//                       <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">Message</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-50">
//                     {results.map((r, i) => (
//                       <tr key={i} className={r.success ? "bg-emerald-50/30" : "bg-red-50/30"}>
//                         <td className="px-4 py-2.5 font-mono font-medium text-gray-800">{r.code}</td>
//                         <td className="px-4 py-2.5 text-gray-600">{r.ville}</td>
//                         <td className="px-4 py-2.5 text-center">
//                           {r.success
//                             ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700">✓ Mis à jour</span>
//                             : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-red-100 text-red-600">✗ Échec</span>
//                           }
//                         </td>
//                         <td className="px-4 py-2.5 text-gray-500">{r.message}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="flex items-center justify-between px-7 py-4 border-t border-gray-100 shrink-0 bg-gray-50/50">
//           <button
//             onClick={onClose}
//             className="text-xs text-gray-500 hover:text-gray-700 transition-colors px-4 py-2 rounded-xl hover:bg-gray-100"
//           >
//             Fermer
//           </button>

//           {stage === "preview" && (
//             <div className="flex items-center gap-3">
//               <button
//                 onClick={() => { setStage("idle"); setRows([]); setMeta(null); }}
//                 className="text-xs text-gray-500 hover:text-gray-700 transition-colors px-4 py-2 rounded-xl hover:bg-gray-100"
//               >
//                 ← Changer le fichier
//               </button>
//               <button
//                 onClick={handleImport}
//                 disabled={selectedCount === 0}
//                 className="text-xs bg-orange-500 hover:bg-orange-600 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold py-2 px-5 rounded-xl transition-all duration-200"
//               >
//                 Importer {selectedCount} commande{selectedCount > 1 ? "s" : ""}
//               </button>
//             </div>
//           )}

//           {stage === "done" && (
//             <button
//               onClick={() => { setStage("idle"); setRows([]); setMeta(null); setResults([]); }}
//               className="text-xs bg-gray-800 hover:bg-gray-700 text-white font-semibold py-2 px-5 rounded-xl transition-all duration-200"
//             >
//               Nouvelle importation
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import { useState, useRef, useCallback } from "react";
import { BASE_URL } from "../../apiConfig";
import { useAuth } from "../../context/AuthProvider";
import { useLanguage } from "../../context/LanguageProvider";
import { toast } from "sonner";

// ── Extract items WITH their x/y coordinates from pdf.js ─────────────────────
async function extractTokensFromPDF(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const typedarray = new Uint8Array(e.target.result);
        const pdfjsLib = window["pdfjs-dist/build/pdf"];
        if (!pdfjsLib) throw new Error("pdf.js not loaded");
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

        const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;

        // Collect positioned items across all pages
        const allItems = [];
        let pageYOffset = 0;

        for (let p = 1; p <= pdf.numPages; p++) {
          const page = await pdf.getPage(p);
          const viewport = page.getViewport({ scale: 1 });
          const content = await page.getTextContent();

          content.items.forEach((item) => {
            const t = item.str.trim();
            if (!t) return;
            // transform[4] = x,  transform[5] = y (PDF coords, bottom-up)
            const x = item.transform[4];
            const y = viewport.height - item.transform[5] + pageYOffset; // flip to top-down
            allItems.push({ text: t, x, y });
          });

          pageYOffset += viewport.height + 20; // stack pages vertically
        }

        resolve(allItems);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

// ── Parse using X-column bands (from debug: code=66, dates=169/233, status=298, ville=352, crbt=422, frais=476, total=519)
function parseOzonInvoice(items) {
  const flat = items.map((i) => i.text).join(" ");

  // Meta
  const invoiceMatch = flat.match(/Facture\s*:\s*(FCT-[\w-]+)/i);
  const dateMatch    = flat.match(/Date\s*:\s*([\d-]+\s[\d:]+)/i);
  const totalMatch   = flat.match(/Total\s*Net\s*([\d,.]+)/i) || flat.match(/Total\s*:\s*([\d,.]+)\s*DH/i);
  const colisMatch   = flat.match(/Colis\s*:\s*(\d+)/i);

  const meta = {
    invoice : invoiceMatch?.[1] ?? "–",
    date    : dateMatch?.[1]    ?? "–",
    total   : totalMatch?.[1]   ?? "–",
    colis   : colisMatch?.[1]   ?? "–",
  };

  // Column X ranges (with tolerance ±15px)
  // From debug: code≈66, dateRam≈169, dateLiv≈233, status≈298, ville≈352, crbt≈422, frais≈476, total≈519
  const inCol = (x, center) => Math.abs(x - center) < 20;

  const COL_CODE   = 66;
  const COL_DRAM   = 169;
  const COL_DLIV   = 233;
  const COL_STATUS = 298;
  const COL_VILLE  = 352;
  const COL_CRBT   = 422;
  const COL_FRAIS  = 476;
  const COL_TOTAL  = 519;

  const DATE_RE  = /^\d{4}-\d{2}-\d{2}$/;
  const PHONE_RE = /^0\d{9}$/;
  const extractAmount = (t) => { const m = t.match(/^([\d]+([.,]\d+)?)\s*(?:DH)?$/i); return m ? m[1] : null; };

  // Filter only table items (y > 200, x between 30–560, skip header/footer text)
  const tableItems = items.filter(item => {
    if (item.y < 200) return false; // above table
    if (item.x < 30 || item.x > 560) return false;
    const t = item.text;
    if (["DH", "N°", "1 / 2", "2 / 2"].includes(t)) return false;
    if (/^(ramassage|livraison|Total|Sauf|Ozon|Powered)/i.test(t)) return false;
    return true;
  });

  // Find all Y positions that have a row-number at x≈34 (the leftmost column)
  // These Y values anchor each invoice row
  const rowNumberItems = tableItems.filter(item =>
    item.x < 50 && /^\d{1,2}$/.test(item.text)
  ).sort((a, b) => a.y - b.y);

  const rows = [];

  for (let ri = 0; ri < rowNumberItems.length; ri++) {
    const anchorY = rowNumberItems[ri].y;
    const nextAnchorY = rowNumberItems[ri + 1]?.y ?? anchorY + 60;

    // Grab all items belonging to this invoice row (between this anchor and next)
    const block = tableItems.filter(item =>
      item.y >= anchorY - 2 && item.y < nextAnchorY - 2
    );

    // Collect text per column by X band, sorted by Y then X
    const col = (center) => block
      .filter(item => inCol(item.x, center))
      .sort((a, b) => a.y - b.y || a.x - b.x)
      .map(i => i.text);

    // Code column: may be "OZN-" + "TOPSELLER-169" across two lines → join
    const codeTokens = col(COL_CODE).filter(t => !/^\d{1,2}$/.test(t) && !PHONE_RE.test(t) && !DATE_RE.test(t));
    const rawCode = codeTokens.join("").replace(/\s+/g, "");
    if (!rawCode.toUpperCase().startsWith("OZN")) continue; // skip non-order rows

    // Phone: first 10-digit token in code column
    const phone = col(COL_CODE).find(t => PHONE_RE.test(t)) ?? "–";

    // Dates
    const dateRamTokens = col(COL_DRAM).filter(t => DATE_RE.test(t));
    const dateLivTokens = col(COL_DLIV).filter(t => DATE_RE.test(t));
    const dateRamassage = dateRamTokens[0] ?? "–";
    const dateLivraison = dateLivTokens[0] ?? "–";

    // Status
    const status = col(COL_STATUS).find(t => /^(livr|refus|retourn|annul|report)/i.test(t)) ?? "–";

    // Ville: join all tokens in ville column
    const ville = col(COL_VILLE)
      .filter(t => t !== "DH")
      .join(" ")
      .trim();

    // Amounts — strip "DH" suffix if merged
    const crbtRaw  = col(COL_CRBT).find(t => extractAmount(t) !== null) ?? "0";
    const fraisRaw = col(COL_FRAIS).find(t => extractAmount(t) !== null) ?? "0";
    const totalRaw = col(COL_TOTAL).find(t => extractAmount(t) !== null) ?? "0";

    const crbt  = extractAmount(crbtRaw)  ?? crbtRaw;
    const frais = extractAmount(fraisRaw) ?? fraisRaw;
    const total = extractAmount(totalRaw) ?? totalRaw;

    rows.push({
      code: rawCode,
      phone,
      dateRamassage,
      dateLivraison,
      status,
      ville,
      crbt,
      frais,
      total,
      selected: status.toLowerCase().startsWith("livr"),
    });
  }

  return { meta, rows };
}

// ── Status badge ───────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const { t } = useLanguage();
  const s = status.toLowerCase();
  if (s === "livré")
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700 border border-emerald-200">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
        {t('modals.ozon_invoice.status_delivered')}
      </span>
    );
  if (s === "refusé")
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-red-100 text-red-600 border border-red-200">
        <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
        {t('modals.ozon_invoice.status_refused')}
      </span>
    );
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-600 border border-gray-200">
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
      {status}
    </span>
  );
}

// ── Main component ─────────────────────────────────────────────────────────────
export default function OzonInvoiceImporter({ onClose }) {
  const { t } = useLanguage();
  const { token } = useAuth();
  const fileRef = useRef();

  const [stage, setStage] = useState("idle"); // idle | parsing | preview | importing | done
  const [meta, setMeta] = useState(null);
  const [rows, setRows] = useState([]);
  const [results, setResults] = useState([]); // { code, success, message }
  const [dragging, setDragging] = useState(false);
  const [error, setError] = useState("");

  // ── File handling ────────────────────────────────────────────────────────────
  const handleFile = useCallback(async (file) => {
    if (!file || file.type !== "application/pdf") {
      setError(t('modals.ozon_invoice.select_pdf'));
      return;
    }
    setError("");
    setStage("parsing");
    try {
      const items = await extractTokensFromPDF(file);
      const { meta, rows } = parseOzonInvoice(items);
      setMeta(meta);
      setRows(rows);
      setStage("preview");
    } catch (err) {
      setError(t('modals.ozon_invoice.error') + " : " + err.message);
      setStage("idle");
    }
  }, []);

  const onDrop = useCallback(
    (e) => {
      e.preventDefault();
      setDragging(false);
      handleFile(e.dataTransfer.files[0]);
    },
    [handleFile]
  );

  const toggleRow = (idx) =>
    setRows((prev) =>
      prev.map((r, i) => (i === idx ? { ...r, selected: !r.selected } : r))
    );

  const toggleAll = () => {
    const livreRows = rows.filter((r) => r.status.toLowerCase() === "livré");
    const allSelected = livreRows.every((r) => r.selected);
    setRows((prev) =>
      prev.map((r) =>
        r.status.toLowerCase() === "livré" ? { ...r, selected: !allSelected } : r
      )
    );
  };

  // ── Import: call backend for each selected "Livré" order ─────────────────────
  const handleImport = async () => {
    const selected = rows.filter((r) => r.selected && r.status.toLowerCase() === "livré");
    if (!selected.length) {
      toast.warning(t('modals.ozon_invoice.no_orders_selected'));
      return;
    }

    setStage("importing");
    const res = [];

    for (const row of selected) {
      try {
        const response = await fetch(`${BASE_URL}/api/ozon-update-status`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code_api: row.code,
            status: "Livre(paye)",
          }),
        });
        const data = await response.json();
        res.push({
          code: row.code,
          ville: row.ville,
          success: response.ok && data.success,
          message: data.message ?? (response.ok ? t('modals.ozon_invoice.updated') : t('modals.ozon_invoice.error')),
        });
      } catch (err) {
        res.push({ code: row.code, ville: row.ville, success: false, message: err.message });
      }
    }

    setResults(res);
    setStage("done");

    const ok = res.filter((r) => r.success).length;
    const fail = res.filter((r) => !r.success).length;
    if (fail === 0) toast.success(t('modals.ozon_invoice.updated_success', { count: ok }));
    else toast.warning(t('modals.ozon_invoice.partial_success', { ok, fail }));
  };

  // ── Derived ──────────────────────────────────────────────────────────────────
  const livreCount = rows.filter((r) => r.status.toLowerCase() === "livré").length;
  const selectedCount = rows.filter((r) => r.selected).length;
  const allLivreSelected =
    livreCount > 0 && rows.filter((r) => r.status.toLowerCase() === "livré").every((r) => r.selected);

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col overflow-hidden border border-gray-100">

        {/* Header */}
        <div className="flex items-center justify-between px-7 py-5 border-b border-gray-100 shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-orange-100 flex items-center justify-center">
              <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div>
              <h2 className="text-base font-bold text-gray-900">{t('modals.ozon_invoice.title')}</h2>
              {meta && (
                <p className="text-[11px] text-gray-400 mt-0.5">
                  {meta.invoice} · {meta.date} · {meta.colis} colis · {meta.total} DH
                </p>
              )}
            </div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto px-7 py-6">

          {/* ── IDLE / DROP ZONE ── */}
          {(stage === "idle" || stage === "parsing") && (
            <div
              onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
              onDragLeave={() => setDragging(false)}
              onDrop={onDrop}
              onClick={() => fileRef.current?.click()}
              className={`border-2 border-dashed rounded-2xl flex flex-col items-center justify-center cursor-pointer select-none transition-all duration-200 py-16
                ${dragging ? "border-orange-400 bg-orange-50" : "border-gray-200 bg-gray-50 hover:border-orange-300 hover:bg-orange-50/50"}`}
            >
              <input
                ref={fileRef}
                type="file"
                accept="application/pdf"
                className="hidden"
                onChange={(e) => handleFile(e.target.files[0])}
              />
              {stage === "parsing" ? (
                <>
                  <div className="w-10 h-10 border-4 border-orange-400 border-t-transparent rounded-full animate-spin mb-4" />
                  <p className="text-sm text-gray-500 font-medium">{t('modals.ozon_invoice.reading_pdf')}</p>
                </>
              ) : (
                <>
                  <div className="w-14 h-14 rounded-2xl bg-orange-100 flex items-center justify-center mb-4">
                    <svg className="w-7 h-7 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                  </div>
                  <p className="text-sm font-semibold text-gray-700 mb-1">{t('modals.ozon_invoice.drop_pdf')}</p>
                  <p className="text-xs text-gray-400">{t('modals.ozon_invoice.click_to_select')}</p>
                </>
              )}
              {error && (
                <p className="mt-4 text-xs text-red-500 bg-red-50 px-4 py-2 rounded-xl">{error}</p>
              )}
            </div>
          )}

          {/* ── PREVIEW ── */}
          {stage === "preview" && (
            <>
              {/* Summary pills */}
              <div className="flex flex-wrap gap-3 mb-5">
                <span className="px-3 py-1.5 bg-gray-100 rounded-xl text-xs font-medium text-gray-600">
                  {t('modals.ozon_invoice.total_colis')} <strong>{rows.length}</strong>
                </span>
                <span className="px-3 py-1.5 bg-emerald-50 rounded-xl text-xs font-medium text-emerald-700 border border-emerald-100">
                  {t('modals.ozon_invoice.delivered')} <strong>{livreCount}</strong>
                </span>
                <span className="px-3 py-1.5 bg-red-50 rounded-xl text-xs font-medium text-red-600 border border-red-100">
                  {t('modals.ozon_invoice.refused')} <strong>{rows.filter(r => r.status.toLowerCase() === "refusé").length}</strong>
                </span>
                <span className="px-3 py-1.5 bg-orange-50 rounded-xl text-xs font-medium text-orange-600 border border-orange-100">
                  {t('modals.ozon_invoice.selected')} <strong>{selectedCount}</strong>
                </span>
              </div>

              <div className="rounded-2xl border border-gray-100 overflow-hidden">
                <table className="w-full text-xs">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left">
                        <input
                          type="checkbox"
                          checked={allLivreSelected}
                          onChange={toggleAll}
                          className="rounded accent-orange-500"
                          title={t('modals.ozon_invoice.select_all_delivered')}
                        />
                      </th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_code')}</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_phone')}</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_city')}</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_status')}</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_crbt')}</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_fees')}</th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.table_net')}</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {rows.map((row, idx) => {
                      const isLivre = row.status.toLowerCase() === "livré";
                      return (
                        <tr
                          key={idx}
                          onClick={() => isLivre && toggleRow(idx)}
                          className={`transition-colors ${isLivre ? "cursor-pointer hover:bg-orange-50/40" : "opacity-50"} ${row.selected ? "bg-orange-50/60" : ""}`}
                        >
                          <td className="px-4 py-2.5">
                            <input
                              type="checkbox"
                              checked={row.selected}
                              disabled={!isLivre}
                              onChange={() => toggleRow(idx)}
                              className="rounded accent-orange-500"
                            />
                          </td>
                          <td className="px-4 py-2.5 font-mono font-medium text-gray-800">{row.code}</td>
                          <td className="px-4 py-2.5 text-gray-500">{row.phone}</td>
                          <td className="px-4 py-2.5 text-gray-600">{row.ville}</td>
                          <td className="px-4 py-2.5 text-center"><StatusBadge status={row.status} /></td>
                          <td className="px-4 py-2.5 text-right font-medium text-gray-700">{row.crbt} DH</td>
                          <td className="px-4 py-2.5 text-right text-red-500">-{row.frais} DH</td>
                          <td className="px-4 py-2.5 text-right font-bold text-emerald-700">{row.total} DH</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <p className="mt-4 text-xs text-gray-400 text-center">
                {t('modals.ozon_invoice.info_only_delivered')}
              </p>
            </>
          )}

          {/* ── IMPORTING ── */}
          {stage === "importing" && (
            <div className="flex flex-col items-center justify-center py-16 gap-4">
              <div className="w-12 h-12 border-4 border-orange-400 border-t-transparent rounded-full animate-spin" />
              <p className="text-sm font-semibold text-gray-700">{t('modals.ozon_invoice.updating_orders')}</p>
              <p className="text-xs text-gray-400">{t('modals.ozon_invoice.please_wait')}</p>
            </div>
          )}

          {/* ── DONE ── */}
          {stage === "done" && (
            <>
              <div className="flex flex-wrap gap-3 mb-5">
                <span className="px-3 py-1.5 bg-emerald-50 rounded-xl text-xs font-medium text-emerald-700 border border-emerald-100">
                    {t('modals.ozon_invoice.success_count')} <strong>{results.filter(r => r.success).length}</strong>
                </span>
                {results.filter(r => !r.success).length > 0 && (
                  <span className="px-3 py-1.5 bg-red-50 rounded-xl text-xs font-medium text-red-600 border border-red-100">
                    {t('modals.ozon_invoice.fail_count')} <strong>{results.filter(r => !r.success).length}</strong>
                  </span>
                )}
              </div>

              <div className="rounded-2xl border border-gray-100 overflow-hidden">
                <table className="w-full text-xs">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.result_code')}</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.result_city')}</th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.result_status')}</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">{t('modals.ozon_invoice.result_message')}</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {results.map((r, i) => (
                      <tr key={i} className={r.success ? "bg-emerald-50/30" : "bg-red-50/30"}>
                        <td className="px-4 py-2.5 font-mono font-medium text-gray-800">{r.code}</td>
                        <td className="px-4 py-2.5 text-gray-600">{r.ville}</td>
                        <td className="px-4 py-2.5 text-center">
                          {r.success
                            ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700">{t('modals.ozon_invoice.result_updated')}</span>
                            : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-red-100 text-red-600">{t('modals.ozon_invoice.result_failed')}</span>
                          }
                        </td>
                        <td className="px-4 py-2.5 text-gray-500">{r.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between px-7 py-4 border-t border-gray-100 shrink-0 bg-gray-50/50">
          <button
            onClick={onClose}
            className="text-xs text-gray-500 hover:text-gray-700 transition-colors px-4 py-2 rounded-xl hover:bg-gray-100"
          >
            {t('modals.ozon_invoice.close')}
          </button>

          {stage === "preview" && (
            <div className="flex items-center gap-3">
              <button
                onClick={() => { setStage("idle"); setRows([]); setMeta(null); }}
                className="text-xs text-gray-500 hover:text-gray-700 transition-colors px-4 py-2 rounded-xl hover:bg-gray-100"
              >
                {t('modals.ozon_invoice.change_file')}
              </button>
              <button
                onClick={handleImport}
                disabled={selectedCount === 0}
                className="text-xs bg-orange-500 hover:bg-orange-600 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold py-2 px-5 rounded-xl transition-all duration-200"
              >
                {t('modals.ozon_invoice.import_count', { count: selectedCount })}
              </button>
            </div>
          )}

          {stage === "done" && (
            <button
              onClick={() => { setStage("idle"); setRows([]); setMeta(null); setResults([]); }}
              className="text-xs bg-gray-800 hover:bg-gray-700 text-white font-semibold py-2 px-5 rounded-xl transition-all duration-200"
            >
              {t('modals.ozon_invoice.new_import')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}